import { Languages, SearchableArticleInstantSearch } from '@livv/models';
import { completePreviewLink, getArticleLink } from '@livv/utils/helpers';
import { fromUnixTime } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from './ContentCard';
import { APP_URL } from '@utils/consts/livv';
import { getDate } from '@utils/date';
import { getFullTextSearchQuery } from '@utils/search/snippet';

interface ArticlePreviewProps extends PreviewCardProps<SearchableArticleInstantSearch> {
    query: string;
}

const ArticlePreview: FC<ArticlePreviewProps> = ({ hit, query }) => {
    const { baseObjectID, createdAt } = hit;
    const { t, lang } = useTranslation('article');
    const baseHref = getArticleLink(baseObjectID);

    return (
        <ContentCard
            hit={hit}
            href={completePreviewLink(baseHref, APP_URL, getFullTextSearchQuery(hit, query))}
            secondaryAttributes={[
                {
                    attribute: getDate(fromUnixTime(createdAt), lang as Languages),
                    label: t('publishedAt'),
                },
            ]}
            snippetAttribute="fullText"
            subtitleAttributes={[{ attribute: 'subtitle' }]}
            titleAttribute="title"
        />
    );
};

export default ArticlePreview;
